module.exports = __webpack_public_path__ + "img/duplicate-playlist.8adfe692.svg";